import { render } from "./StudentCTA.vue?vue&type=template&id=5cb38332&scoped=true"
import script from "./StudentCTA.vue?vue&type=script&lang=js"
export * from "./StudentCTA.vue?vue&type=script&lang=js"

import "./StudentCTA.vue?vue&type=style&index=0&id=5cb38332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb38332"]])

export default __exports__